<template>
  <v-card :loading="loading" :disabled="loading" elevation="0">
    <v-card-text class="pa-0">
      <div class="text-center">
        <h2>
          {{ $t("pre_regis_add_subject.list_subject_need_to_regis") }}
        </h2>
        <v-simple-table dense class="mt-2">
          <template v-slot:default>
            <thead>
              <!-- --------------------------------------------------------------- -->
              <!-- Table Header -->
              <tr>
                <th class="text-center delete">
                  {{ $t("pre_regis_add_subject.delete") }}
                </th>
                <th class="text-center subject-id">
                  {{ $t("pre_regis_add_subject.subject_id") }}
                </th>
                <th class="text-center subject-name">
                  {{ $t("pre_regis_add_subject.subject_name") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.credit") }}
                </th>
                <th class="text-center section">
                  {{ $t("pre_regis_add_subject.section") }}
                </th>
                <th class="text-center subject-type">
                  {{ $t("pre_regis_add_subject.type") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.class_exam_timetable") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.limit") }}
                </th>
                <th class="text-center last-cell">
                  {{ $t("regis_add_subject.number_of_people_registered_x") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- --------------------------------------------------------------- -->
              <!-- Table Display registered -->
              <tr
                v-if="
                  !computed_registering_subject_list ||
                  computed_registering_subject_list.length === 0
                "
              >
                <td class="last-cell text-center" colspan="9">
                  {{ $t("queue_table_panel.no_item") }}
                </td>
              </tr>
              <tr
                v-for="item in computed_registering_subject_list"
                :key="item.name"
                :class="item.valid === false ? 'red lighten-5' : ''"
              >
                <td>
                  <v-btn
                    icon
                    v-on:click="remove_registering_subject(item.subject_id)"
                  >
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <!-- <v-btn
                    icon
                    v-on:click="remove_registering_subject(item.subject_id)"
                  >
                    <v-icon color="orange">mdi-square-edit-outline</v-icon>
                  </v-btn> -->
                </td>
                <td
                  :class="
                    item.valid === false ? 'red--text font-weight-bold' : ''
                  "
                >
                  {{ item.subject_id }}
                </td>
                <td
                  :class="
                    item.valid === false ? 'red--text font-weight-bold' : ''
                  "
                >
                  <a class="subject-link" @click="openSubjectDialog(item.subject_id)">
                    {{ item.subject_ename }}
                  </a>
                </td>
                <td>
                  <class-hour-text
                    show_lect_or_prac
                    :item="item"
                  ></class-hour-text>
                </td>
                <td>
                  {{ item.section }}
                  {{
                    item.has_same_section
                      ? " (" +
                        inlineTranslator({
                          en: item.curr2_ename,
                          th: item.curr2_tname,
                        }) +
                        ")"
                      : ""
                  }}
                </td>
                <td>{{ item.subject_type }}</td>
                <td class="full-width">
                  <teach-and-exam-time
                    :item="item"
                    :show_timeslot_dropdown="false"
                  ></teach-and-exam-time>
                </td>
                <td
                  :class="
                    item.valid === false ? 'red--text font-weight-bold' : ''
                  "
                >
                  {{ item.LIMIT != "0" ? item.LIMIT : "-" }}
                </td>
                <td
                  :class="
                    item.valid === false
                      ? 'red--text font-weight-bold last-cell'
                      : 'last-cell'
                  "
                >
                  {{ item.COUNT }}
                </td>
              </tr>
              <tr class="table-space-tr" height="50px">
                <td class="table-space-td" colspan="9">
                  {{ $t("pre_regis_add_subject.add_description") }}
                </td>
              </tr>
              <!-- --------------------------------------------------------------- -->
              <!-- Add subject -->
              <tr :style="subject_adding_color">
                <td>
                  <v-btn
                    v-if="adding_subject_id.length === 8"
                    icon
                    v-on:click="clear_adding_subject_id()"
                  >
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-text-field
                    @input="search_subject()"
                    outlined
                    dense
                    hide-details
                    v-model="adding_subject_id"
                    :disabled="searched_subjects !== null"
                    class="ma-1"
                  ></v-text-field>
                </td>
                <td>
                  <div v-if="has_primary">
                    <a class="subject-link" @click="openSubjectDialog(all_primary[0].subject_id)">
                      {{ all_primary[0].subject_ename }}
                    </a>
                  </div>
                </td>
                <td>
                  <div v-if="has_primary">
                    <class-hour-text
                      show_lect_or_prac
                      :item="all_primary[0]"
                    ></class-hour-text>
                  </div>
                </td>
                <td>
                  <div v-if="has_primary">
                    <v-select
                      v-model="selected_primary_subject_section"
                      dense
                      hide-details
                      class="ma-1"
                      outlined
                      :items="all_primary"
                      :item-text="
                        (item) =>
                          item.section +
                          (item.has_same_section
                            ? ' (' +
                              inlineTranslator({
                                en: item.curr2_ename,
                                th: item.curr2_tname,
                              }) +
                              ')'
                            : '')
                      "
                      :item-value="(item) => item"
                      @change="(e) => select_section(e)"
                    ></v-select>
                  </div>
                </td>
                <td>
                  <div
                    v-if="has_primary && all_primary[0].subject_type !== 'T'"
                  >
                    <v-select
                      v-model="selected_subject_type"
                      dense
                      hide-details
                      class="ma-1"
                      outlined
                      :items="subject_type_list"
                      :item-value="(item) => item"
                    ></v-select>
                  </div>
                  <div v-else-if="has_primary">Cr</div>
                </td>
                <td>
                  <div
                    class="full-width"
                    v-if="has_primary && selected_primary_subject_section"
                  >
                    <teach-and-exam-time
                      :item="selected_primary_subject_section"
                      :show_timeslot_dropdown="false"
                    ></teach-and-exam-time>
                  </div>
                </td>
                <td>
                  <div v-if="selected_primary_subject_section">
                    {{
                      selected_primary_subject_section.LIMIT != "0"
                        ? selected_primary_subject_section.LIMIT
                        : "-"
                    }}
                  </div>
                </td>
                <td class="last-cell">
                  <div v-if="selected_primary_subject_section">
                    {{ selected_primary_subject_section.COUNT }}
                  </div>
                </td>
              </tr>
              <!-- --------------------------------------------------------------- -->
              <!-- Add subject Practice -->
              <tr
                :style="subject_adding_color"
                v-if="is_has_theory_and_practice"
              >
                <td></td>
                <td>{{ $t("pre_regis_add_subject.practice") }}</td>
                <td>
                  <div v-if="has_secondary">
                    <a class="subject-link" @click="openSubjectDialog(all_secondary[0].subject_id)">
                      {{ all_secondary[0].subject_ename }}
                    </a>
                  </div>
                </td>
                <td>
                  <div v-if="has_secondary">
                    <class-hour-text
                      show_lect_or_prac
                      :item="all_secondary[0]"
                    ></class-hour-text>
                  </div>
                </td>
                <td>
                  <div
                    v-if="
                      has_secondary &&
                      is_lock_practice_section &&
                      selected_secondary_subject_section
                    "
                  >
                    {{ selected_secondary_subject_section.section }}
                  </div>
                  <div v-if="has_secondary && !is_lock_practice_section">
                    <v-select
                      v-model="selected_secondary_subject_section"
                      dense
                      hide-details
                      class="ma-1"
                      outlined
                      :items="all_secondary"
                      :item-text="
                        (item) =>
                          item.section +
                          (item.has_same_section
                            ? ' (' + item.curr2_tname + ')'
                            : '')
                      "
                      :item-value="(item) => item"
                      @change="(e) => select_section(e, true)"
                    ></v-select>
                  </div>
                </td>
                <td>{{ selected_subject_type }}</td>
                <td>
                  <div
                    class="full-width"
                    v-if="has_secondary && selected_secondary_subject_section"
                  >
                    <teach-and-exam-time
                      :item="selected_secondary_subject_section"
                      :show_timeslot_dropdown="false"
                    ></teach-and-exam-time>
                  </div>
                </td>
                <td>
                  <div v-if="selected_secondary_subject_section">
                    {{
                      selected_secondary_subject_section.LIMIT != "0"
                        ? selected_secondary_subject_section.LIMIT
                        : "-"
                    }}
                  </div>
                </td>
                <td class="last-cell">
                  <div v-if="selected_secondary_subject_section">
                    {{ selected_secondary_subject_section.COUNT }}
                  </div>
                </td>
                <!-- --------------------------------------------------------------- -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div class="text-right mt-1">
          {{ $t("registration.subject_type_description") }}
        </div>

        <div>
          <v-btn
            elevation="0"
            class="green white--text"
            :disabled="subject_adding_status !== 1"
            @click="add_subject_to_list()"
            >{{ $t("pre_regis_add_subject.add") }}</v-btn
          >
        </div>

        <!-- ดำเนินการต่อ -->
        <v-btn
          class="mt-5 deep-orange white--text"
          v-on:click="confirm_regis_dialog = true"
          :disabled="!can_confirm"
          >{{ $t("pre_regis_add_subject.continuous") }}
        </v-btn>

        <v-dialog
          width="500"
          v-model="confirm_grade_not_announce_dialog"
          persistent
        >
          <v-card>
            <v-card-title>
              {{ $t("pre_regis_add_subject.grade_not_release") }}
            </v-card-title>
            <v-card-text>
              <div style="font-size: 16px; line-height: 1.5em">
                {{ $t("pre_regis_add_subject.subject_id") }}
                {{ adding_subject_id }}
                {{ $t("pre_regis_add_subject.prerequisite_has_no_grade") }}
                <span
                  v-for="(item, index) in subject_id_grade_not_announce"
                  :key="index"
                  class="mr-3"
                >
                  {{ item }}
                </span>
                <br />
                <br />
                {{ $t("pre_regis_add_subject.confirm_on_registration_date") }}
                {{ adding_subject_id }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                @click="confirm_grade_not_announce_dialog = false"
                >{{ $t("pre_regis_add_subject.roger") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog width="500" v-model="confirm_regis_dialog" persistent>
          <v-card>
            <v-card-title>{{
              $t("regis_add_subject.one_time_registration")
            }}</v-card-title>
            <v-card-text>
              <div style="font-size: 18px; line-height: 1.5em">
                {{ $t("regis_add_subject.one_time_regis_cannot_edit") }}
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn color="warning" @click="confirm_regis_dialog = false">{{
                $t("pre_regis_add_subject.back")
              }}</v-btn>
              <v-btn dark color="deep-orange" @click="submit()">{{
                $t("pre_regis_add_subject.confirm")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <credit-box
        :summary_credit="summary_credit"
        :max_credit="max_credit"
        :min_credit="min_credit"
      ></credit-box>
      <subject-dialog ref="subject_dialog" :level-id="level_id" />
    </v-card-text>
  </v-card>
</template>

<script>
import ClassHourText from "./ClassHourText.vue";
import TeachAndExamTime from "./TeachAndExamTime.vue";
import { check_integrity_time } from "@/helper/registration";
import { computed_subject_list } from "@/helper/registration";
import RegistrationProvider from "@/services/registration.provider.js";
import CreditBox from "./CreditBox.vue";
import {
  objectTranslatorLowerCase,
  inlineTranslator,
} from "@/helper/translator";
import SubjectDialog from "@/views/teach_table/components/SubjectDialog.vue";

const RegistrationService = new RegistrationProvider();
export default {
  components: {
    ClassHourText,
    TeachAndExamTime,
    CreditBox,
    SubjectDialog,
  },
  name: "RegisXAddSubject",
  props: {
    clickNext: {
      type: Function,
    },
    check_never_regis: {
      type: Function,
    },
    level_id: {
      type: Number,
      default: null,
    },
    sub_level_id: {
      type: Number,
      default: null,
    },
    year: {
      type: String,
    },
    semester: {
      type: String,
    },
    student_id: {
      type: String,
    },
    bypass: {
      type: Boolean,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    adding_subject_id: "",
    searched_subjects: null,
    subject_adding_status: 0, // 0 คือยังไม่ได้กรอก หรือยังไม่ได้เลือกเซค, 1 คือ ผ่านเงื่อนไข, 2 คือ ไม่ผ่าน

    confirm_grade_not_announce_dialog: false,
    confirm_regis_dialog: false,
    selected_primary_subject_section: null,
    selected_secondary_subject_section: null,

    subject_type_list: ["Cr", "Ad", "Tr", "Nc"],
    selected_subject_type: "Cr",

    registering_subject_list: [],
    min_credit: null,
    max_credit: null,
    subject_id_grade_not_announce: [],
  }),
  computed: {
    can_confirm() {
      if (this.adding_subject_id.length === 8) return false;
      else if (this.registering_subject_list.length === 0) return false;
      else if (!this.bypass) {
        if (
          (!this.min_credit && !this.max_credit) ||
          this.summary_credit < this.min_credit ||
          this.summary_credit > this.max_credit
        )
          return false;
      }
      return true;
    },
    summary_credit() {
      const temp = this.registering_subject_list.map((item) => {
        const same_subject = this.registering_subject_list.filter(
          (item_2) => item_2.subject_id === item.subject_id
        );
        if (same_subject.length > 1) {
          return { ...item, has_pair: true };
        } else return { ...item, has_pair: false };
      });

      return temp.reduce((sum, item) => {
        if (item.has_pair && item.lect_or_prac === "ป") return sum;

        // Nc ไม่คิดเครติด
        if (item.subject_type === "Nc") return sum;

        return sum + parseInt(item.credit);
      }, 0);
    },
    has_primary() {
      return this.all_primary && this.all_primary[0];
    },
    has_secondary() {
      return this.all_secondary && this.all_secondary[0];
    },
    subject_adding_color() {
      if (this.subject_adding_status === 1) return "background-color: #dbffb8";
      if (this.subject_adding_status === 2) return "background-color: #ffcfcc";
      return "background-color: #fff1d9";
    },
    // จะแปลงพวกวันเรียน วันสอบ ให้อยู่ในตัวแปรที่เหมาะสมต่อการแสดง
    computed_registering_subject_list() {
      return computed_subject_list(this.registering_subject_list);
    },

    // จะแปลงพวกวันเรียน วันสอบ ให้อยู่ในตัวแปรที่เหมาะสมต่อการแสดง
    computed_searched_subjects() {
      if (!this.searched_subjects) return null;
      return computed_subject_list(this.searched_subjects);
    },

    // จะเป็น true ถ้ากำลัง add วิชา และมีโปรแกรมจับคู่ปฏิบัติเข้ามา
    is_has_theory_and_practice() {
      if (!this.computed_searched_subjects) return false;
      let has_theory = false;
      let has_practice = false;
      this.computed_searched_subjects.map((item) => {
        if (item.lect_or_prac === "ท") has_theory = true;
        if (item.lect_or_prac === "ป") has_practice = true;
      });
      return has_theory && has_practice;
    },

    all_primary() {
      if (this.computed_searched_subjects === null) return null;
      if (this.is_has_theory_and_practice)
        return this.computed_searched_subjects.filter(
          (item) => item.lect_or_prac === "ท"
        );
      else return this.computed_searched_subjects;
    },

    all_secondary() {
      if (this.computed_searched_subjects === null) return null;
      if (!this.is_has_theory_and_practice) return null;
      if (!this.selected_primary_subject_section) return null;
      return this.computed_searched_subjects.filter(
        (item) =>
          item.lect_or_prac === "ป" &&
          (item.sec_pair === this.selected_primary_subject_section.section ||
            item.sec_pair === null)
      );
    },

    is_lock_practice_section() {
      if (!this.selected_primary_subject_section) return true;
      if (this.selected_primary_subject_section.sec_pair !== null) return true;
      return false;
    },

    locked_section_practice() {
      if (
        this.is_lock_practice_section &&
        this.selected_primary_subject_section
      )
        return this.all_secondary.find(
          (item) =>
            item.section === this.selected_primary_subject_section.sec_pair
        );
      return null;
    },
  },
  methods: {
    objectTranslatorLowerCase,
    inlineTranslator,
    openSubjectDialog(subjectId) {
      if (this.$refs.subject_dialog) {
        this.$refs.subject_dialog.show_item_detail(subjectId);
      }
    },
    is_in_registering(teach_table_id) {
      // เอาไว้แสดงสีของตัวที่ได้สิทธิ์ว่าอันไหนกำลังลงอยู่ จะได้มองเห็นง่ายๆ
      return this.registering_subject_list.reduce(
        (ret, item) => ret || item.teach_table_id == teach_table_id,
        false
      );
    },

    async get_student_credit() {
      const data = await RegistrationService.getStudentCredit({
        level_id: this.level_id,
        semester: this.semester,
        student_id: this.student_id,
        sub_level_id: this.sub_level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.min_credit = parseInt(data.check_lower_credit);
      this.max_credit = parseInt(data.check_higher_credit);
    },

    async submit() {
      this.loading = true;
      this.confirm_regis_dialog = false;
      const teach_table_id_list = this.registering_subject_list.map(
        (item) => item.teach_table_id
      );
      const subject_type_list = this.registering_subject_list.map(
        (item) => item.subject_type
      );
      const credit_list = this.registering_subject_list.map(
        (item) => item.credit
      );

      const response = await RegistrationService.regis({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        level_id: this.level_id,
        teach_table_id_list,
        sub_level_id: this.sub_level_id,
        subject_type_list,
        credit_list,
        bypass: this.bypass,
      }).catch((error) => {
        this.loading = false;
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
      });

      if (response) {
        if (!response.status) {
          this.$toasted.error(
            "มีบางวิชามีนักศึกษาลงทะเบียนครบแล้ว กรุณาเปลี่ยนเป็นวิชาหรือกลุ่มอื่น โดยระบบจะเปิดการเข้าแถวคอยในช่วงเพิ่มเปลี่ยนถอนอีกครั้ง",
            { duration: 0 }
          );

          this.registering_subject_list = this.registering_subject_list.map(
            (item) => {
              const response_subject = response.teach_table_data.find(
                (item_2) => item_2.TEACH_TABLE_ID === item.teach_table_id
              );
              if (response_subject)
                return {
                  ...item,
                  COUNT: response_subject.COUNT,
                  PRE_COUNT_Y_LEFT: response_subject.PRE_COUNT_Y_LEFT,
                  valid: response_subject.valid,
                };
              else return { ...item };
            }
          );
        } else {
          this.$toasted.clear();
          this.$toasted.success("ลงทะเบียนสำเร็จ", { duration: 0 });
          this.check_never_regis();
          // this.clickNext();
        }
      }
      this.loading = false;
    },

    async submit_2() {
      await this.submit();
    },

    remove_registering_subject(subject_id) {
      this.registering_subject_list = this.registering_subject_list.filter(
        (item) => item.subject_id !== subject_id
      );
    },

    clear_adding_subject_id() {
      this.adding_subject_id = "";
      this.searched_subjects = null;
      this.subject_adding_status = 0;
      this.selected_primary_subject_section = null;
      this.selected_secondary_subject_section = null;
      this.selected_subject_type = "Cr";
    },

    add_subject_to_list() {

      if (this.selected_primary_subject_section) {
        this.selected_primary_subject_section.subject_type =
          this.selected_subject_type; // เพิ่ม subject_type

        this.selected_primary_subject_section.is_secondary = false; // เพิ่ม is_secondary

        this.registering_subject_list.push(
          this.selected_primary_subject_section
        );
      }
      if (this.selected_secondary_subject_section) {
        this.selected_secondary_subject_section.subject_type =
          this.selected_subject_type; // เพิ่ม subject_type

        this.selected_secondary_subject_section.is_secondary = true; // เพิ่ม is_secondary

        this.registering_subject_list.push(
          this.selected_secondary_subject_section
        );
      }
      this.selected_primary_subject_section = null;
      this.selected_secondary_subject_section = null;
      this.selected_subject_type = "Cr";
      this.adding_subject_id = "";
      this.searched_subjects = null;
      this.subject_adding_status = 0;
    },

    async search_subject() {
      this.loading = true;
      if (this.adding_subject_id.length === 8) {
        if (
          this.registering_subject_list.filter(
            (item) => item.subject_id === this.adding_subject_id
          ).length !== 0
        ) {
          this.$toasted.error(
            this.$t("pre_regis_add_subject.error_in_taking_this_course") +
              this.adding_subject_id +
              ": " +
              this.$t("pre_regis_add_subject.already_in_list"),
            { duration: 0 }
          );
          this.searched_subjects = null;
        } else {
          const data =
            await RegistrationService.getCanRegisterByStudentIdAndSubjectIdX({
              subject_id: this.adding_subject_id,
              student_id: this.student_id,
              year: this.year,
              semester: this.semester,
              bypass: this.bypass,
            });
          if (!data.data || data.data.length === 0) {
            this.$toasted.error(
              this.$t("pre_regis_add_subject.error_in_taking_this_course") +
                this.adding_subject_id +
                ": " +
                this.objectTranslatorLowerCase(data.error, "message"),
              { duration: 0 }
            );
          } else {
            if (
              data.subject_id_grade_not_announce &&
              data.subject_id_grade_not_announce.length > 0
            ) {
              this.subject_id_grade_not_announce =
                data.subject_id_grade_not_announce;
              this.confirm_grade_not_announce_dialog = true;
            }
            this.searched_subjects = data.data;
          }
        }
      }
      this.loading = false;
    },

    async select_section(teach_table_object, is_secondary = false) {
      if (!is_secondary) {
        this.selected_secondary_subject_section = null;
      }

      let is_pass_time_condition = false;

      if (!this.is_has_theory_and_practice) {
        is_pass_time_condition = await check_integrity_time(
          this.adding_subject_id,
          this.registering_subject_list,
          teach_table_object
        );
      } else if (
        this.is_has_theory_and_practice &&
        this.selected_secondary_subject_section
      ) {
        is_pass_time_condition = await check_integrity_time(
          this.adding_subject_id,
          this.registering_subject_list,
          teach_table_object,
          this.selected_secondary_subject_section
        );
      } else if (
        this.is_has_theory_and_practice &&
        this.is_lock_practice_section
      ) {
        this.selected_secondary_subject_section = this.locked_section_practice;
        is_pass_time_condition = await check_integrity_time(
          this.adding_subject_id,
          this.registering_subject_list,
          teach_table_object,
          this.locked_section_practice
        );
      }

      if (
        !this.selected_primary_subject_section ||
        (this.is_has_theory_and_practice &&
          !this.selected_secondary_subject_section)
      ) {
        this.subject_adding_status = 0;
      } else if (is_pass_time_condition || this.bypass) {
        this.subject_adding_status = 1;
      } else {
        this.subject_adding_status = 2;
      }
    },

    async fetch_initial_data() {
      this.loading = true;
      await this.get_student_credit();
      this.loading = false;
    },
  },
  created: function () {
    this.fetch_initial_data();
  },
};
</script>

<style lang="scss" scoped>
td {
  border-width: 0px;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #ccc;
}
.last-cell {
  border-right-width: 1px;
}
thead {
  background-color: #ffbd43;
}

thead.pattern {
  background-color: #aaa;
}

th {
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
}

.full-width {
  overflow: hidden;
  white-space: nowrap;
}

.delete {
  min-width: 100px;
  width: 100px;
}

.subject-id {
  min-width: 140px;
  width: 140px;
}

.subject-name {
  min-width: 150px;
}

.section {
  min-width: 80px;
  width: 80px;
}

.subject-type {
  min-width: 110px;
  width: 110px;
}

.table-space-td {
  border-left-width: 0px;
  vertical-align: bottom;
  text-align: left;
}

.table-space-tr:hover {
  background-color: transparent !important;
}

.subject-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-weight: inherit;
}

.subject-link:hover {
  text-decoration: none;
}
</style>
